const chordTypes = {
    'triads': {
        'maj': {
            0: [4, 3],
            1: [3, 5],
            2: [5, 4]
        },
        'min': {
            0: [3, 4],
            1: [4, 5],
            2: [5, 3]
        },
        'dim': {
            0: [3, 3],
            1: [3, 6],
            2: [6, 3]
        },
        'aug': {
            0: [4, 4],
            1: [4, 4],
            2: [4, 4]
        }
    },
    'sevenths': {
        'maj7': {
            0: [4,3,4],
            1: [3,4,1],
            2: [4,1,4],
            3: [1,4,3]
        },
        'dom7': {
            0: [4,3,3],
            1: [3,3,2],
            2: [3,2,4],
            3: [2,4,3]
        },
        'min7': {
            0: [3,4,3],
            1: [4,3,2],
            2: [3,2,3],
            3: [2,3,4]
        },
        'min7b5': {
            0: [3,3,4],
            1: [3,4,2],
            2: [4,2,3],
            3: [2,3,3]
        },
        'minmaj7': {
            0: [3,4,4],
            1: [4,4,1],
            2: [4,1,3],
            3: [1,3,4]
        },
        'dim7': {
            0: [3,3,3],
            1: [3,3,3],
            2: [3,3,3],
            3: [3,3,3]
        },
        'aug7': {
            0: [4,4,2],
            1: [4,2,2],
            2: [2,2,4],
            3: [2,4,4]
        },
        'augmaj7': {
            0: [4,4,3],
            1: [4,3,1],
            2: [3,1,4],
            3: [1,4,4]
        }
    },
    'ninths': {
        '3w7w9w': {
            0: [4,7,3],
            1: [7,1,2],
            2: [1,2,2],
            3: [2,7,1]
        },
        '3w7m9w': {
            0: [4,6,4],
            1: [6,2,2],
            2: [2,2,2],
            3: [2,6,2]
        },
        '3m7w9w': {
            0: [3,8,3],
            1: [8,1,2],
            2: [1,2,1],
            3: [1,8,1]
        },
        '3m7m9w': {
            0: [3,7,4],
            1: [7,2,2],
            2: [2,2,1],
            3: [1,7,2]            
        },
        '3w7m9m': {
            0: [4,6,3],
            1: [6,2,1],
            2: [2,1,2],
            3: [3,6,2]
        },
        '3w7m9zw': {
            0: [4,6,5],
            1: [6,2,3],
            2: [2,3,1],
            3: [1,6,2]
        },
        '5cz7w9w': {
            0: [7,4,3],
            1: [4,1,2],
            2: [1,2,5],
            3: [5,4,1]
        },
        '5cz7m9w': {
            0: [7,3,4],
            1: [3,2,2],
            2: [2,2,5],
            3: [5,3,2]
        },
        '5zm7m9w': {
            0: [6,4,4],
            1: [4,2,2],
            2: [2,2,4],
            3: [4,4,2]
        }
    },
    'elevenths': {
        '3w7w11cz': {
            0: [4,7,6],
            1: [7,1,5],
            2: [1,4,1],
            3: [6,1,4]
        },
        '3w7m11cz': {
            0: [4,6,7],
            1: [6,2,5],
            2: [2,4,1],
            3: [5,2,4]
        },
        '3m7w11cz': {
            0: [3,8,6],
            1: [8,1,5],
            2: [1,3,2],
            3: [6,1,3]
        },
        '3m7m11cz': {
            0: [3,7,7],
            1: [7,2,5],
            2: [2,3,2],
            3: [5,2,3]
        },
        '3w7w11zw': {
            0: [4,7,7],
            1: [7,1,6],
            2: [1,4,2],
            3: [5,1,4]
        },
        '3w7m11zw': {
            0: [4,6,8],
            1: [6,2,6],
            2: [2,4,2],
            3: [4,2,4]
        }
    },
    'thirteenths': {
        '3w13w7w': {
            0: [4,5,2],
            1: [5,2,1],
            2: [2,1,4],
            3: [1,4,5]
        },
        '3m13w7w': {
            0: [3,6,2],
            1: [6,2,1],
            2: [2,1,3],
            3: [1,3,6]
        },
        '3w13w7m': {
            0: [4,5,1],
            1: [5,1,2],
            2: [1,2,4],
            3: [2,4,5]
        },
        '3m13w7m': {
            0: [3,6,1],
            1: [6,1,2],
            2: [1,2,3],
            3: [2,3,6]
        },
        '3w13w9w': {
            0: [4,5,5],
            1: [5,3,2],
            2: [3,2,2],
            3: [2,5,3]
        },
        '3m13w9w': {
            0: [3,6,5],
            1: [6,3,2],
            2: [3,2,1],
            3: [1,6,3]
        },
        '3w13w9m': {
            0: [4,5,4],
            1: [5,3,1],
            2: [3,1,3],
            3: [3,5,3]
        },
        '3m13w9m': {
            0: [3,6,4],
            1: [6,3,1],
            2: [3,1,2],
            3: [2,6,3]
        }
    }
}

export default chordTypes;
